import React from "react";
import { isFunction } from "lodash";
import { css } from "@emotion/core";
import { Colors, useTheme } from "@zapier/design-system";

type Props = {
  isEditing?: boolean;
  renderAside?: () => JSX.Element | null;
  renderLabel?: () => JSX.Element | null;
};

const containerCss = (props: Props) => {
  return {
    border: `1px solid ${props.isEditing ? Colors.ocean : Colors.gray40}`,
    borderRadius: 10,
    padding: 15,
    position: "relative" as const,
  };
};

const rebrandStyle = css`
  border: 1px solid ${Colors.neutral400};
  border-radius: 3px;
  padding: 20px;
`;

const headerCss = css`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
  min-height: 40px;
  @media screen and (max-width: 769px) {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
  }
`;

const rebrandHeaderCss = css`
  align-items: start;
`;

const headerLabelCss = {
  display: "flex",
  alignItems: "center",
  "> *": {
    marginRight: 20,
  },
};

const rebrandHeaderLabelCss = {
  "> *": {
    marginRight: 10,
  },
};

const sectionCss = {
  marginTop: 20,
};

const PaymentMethod: React.FC<Props> = props => {
  const { isRebrand } = useTheme();
  return (
    <section css={[containerCss(props), isRebrand && rebrandStyle]}>
      <header css={[headerCss, isRebrand && rebrandHeaderCss]}>
        <div css={[headerLabelCss, isRebrand && rebrandHeaderLabelCss]}>
          {isFunction(props.renderLabel) && props.renderLabel()}
        </div>
        {isFunction(props.renderAside) && props.renderAside()}
      </header>
      {props.isEditing && props.children && (
        <div css={sectionCss}>{props.children}</div>
      )}
    </section>
  );
};

export default PaymentMethod;
